var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Link as ReactRouterLink, } from "react-router-dom";
var Link = function (_a) {
    var children = _a.children, to = _a.to, props = __rest(_a, ["children", "to"]);
    // Tailor the following test to your environment.
    // This example assumes that any internal link (intended for React)
    // will start with exactly one slash, and that anything else is external.
    var internal = typeof to === "string" ? /^\/(?!\/)/.test(to) : true;
    // Use React Router Link for internal links, and <a> for others
    if (internal || typeof to !== "string") {
        return (_jsx(ReactRouterLink, __assign({ to: to }, props, { children: children }), void 0));
    }
    return (_jsx("a", __assign({ href: to }, props, { children: children }), void 0));
};
export default Link;
//# sourceMappingURL=Link.js.map